import type { SimpleFieldConfig } from "@/components/shared/UniversalCRMTable/types";
import { defineFieldConfigMap } from "@/components/shared/UniversalCRMTable/types/field-config-types";

export const contactDealsFields = defineFieldConfigMap({
  // FIELD: assigned_users
  assigned_users: {
    type: "multi-user",
    label: "Owners",
    sortable: false,
    filterable: true,
    // Quick-filter as a user picker (Me + multi-select). Values are app_users.id[];
    // converted to a GraphQL `overlaps` on the assigned_users array.
    filterType: "user-select",
    resizable: true,
    hideable: true,
    editable: true,
    formSpan: 3,
    width: 200,
    minWidth: 150,
    maxWidth: 300,
    placeholder: "Assign owners",
    icon: "Users",
    allowedRoles: ["wtc_employee", "wtc_admin"],
    multiUserConfig: {
      showUnassigned: true,
      showAllUsers: true,
      maxUsers: 5,
    },
    showOnCard: true,
    cardSpan: 3,
    mobileDetailSectionId: "people",
    savedViewMembership: [
      "all-deals",
      "sales-pipeline",
      "not-followed-up-this-week",
      "scheduled-followups",
      "in-progress",
      "overdue-deals",
      "at-risk",
      "won-deals",
    ],
  },
  /** Delivery engineers (user IDs); distinct from `assigned_users` (sales owners). */
  // FIELD: engineer_ids
  engineer_ids: {
    type: "multi-user",
    label: "Engineers",
    sortable: false,
    filterable: true,
    // Quick-filter as a user picker (Me + multi-select). Values are app_users.id[];
    // converted to a GraphQL `overlaps` on the engineer_ids array.
    filterType: "user-select",
    resizable: true,
    hideable: true,
    editable: true,
    formSpan: 3,
    width: 200,
    minWidth: 150,
    maxWidth: 300,
    placeholder: "Assign engineers",
    icon: "Wrench",
    allowedRoles: ["wtc_employee", "wtc_admin"],
    multiUserConfig: {
      showUnassigned: true,
      showAllUsers: true,
      maxUsers: 5,
    },
    showOnCard: true,
    cardSpan: 3,
    mobileDetailSectionId: "people",
    savedViewMembership: ["all-deals", "in-progress"],
  },
});
